exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-build-version[data-v-8dee4b8a]{margin-top:1rem;font-size:.75rem;text-align:right;color:var(--fts-gray-5)}", ""]);

// exports
